export default __webpack_public_path__ + "static/media/validate.4ad90702.svg";